import React from 'react';

import { Box, Skeleton } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import PageContainer from '../../../components/layout/page-container/PageContainer';
import { useStyles } from './UserPlan.styles';

export default function UserPlanSkeleton() {
  const theme = useTheme();
  const { classes } = useStyles(theme);

  return (
    <PageContainer
      headerContent={
        <Skeleton
          variant="text"
          width={220}
          height={40}
          animation="wave"
          sx={{ mb: 1 }}
        />
      }>
      <div className={classes.subscriptionPlanWrapper}>
        <Skeleton
          variant="rounded"
          width={280}
          height={40}
          animation="wave"
          sx={{ mb: 2 }}
        />
        <Box
          sx={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: 2,
            mb: 2,
          }}>
          {[1, 2, 3].map((i) => (
            <Skeleton
              key={i}
              variant="rounded"
              animation="wave"
              sx={{
                flex: '1 1 200px',
                minHeight: 220,
              }}
            />
          ))}
        </Box>
        <Skeleton
          variant="rounded"
          width="100%"
          height={160}
          animation="wave"
        />
      </div>
    </PageContainer>
  );
}
